export default __webpack_public_path__ + "static/media/chevron_up.e29764ee.svg";